<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Genetic Test Results</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Genetic test results<sup>1</sup></h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    A clinical exome study was performed
                </li>
                <li>Homozygous duplication of 14 base pairs in exon 9 of the <span class="italic">AGXT</span> gene (c.869_882 duplication) was identified
                
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>This duplication causes a frame-shift mutation and premature truncation of the protein, specifically 22 amino acids downstream of codon 295 (p.Ala295SerfsTer22)</li>
                    </ul>
                </li>
                <li>
                    Literature recommends to offer genetic counseling to patients with PH and their families<sup>2</sup>
                </li>
            </ul>
        </div>

        <h2 class="text-2xl md:text-3xl font-semibold text-center">
            Algorithm for Diagnostic Evaluation of PH – Genetic Testing<sup>2–4</sup>
        </h2>

        <img
            src="@/assets/img/graphics/postpartum/genetic-testing-desktop.svg"
            alt="Genetic Testing"
            class="hidden sm:block"
        />
        <img
            src="@/assets/img/graphics/postpartum/genetic-testing-mobile.svg"
            alt="Genetic Testing"
            class="sm:hidden"
        />

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            Genetic confirmation of PH1?<sup>1</sup> Yes
        </h3>
    </div>
</template>
